<p-panel>
    @if (!formReady) {
        <div class="d-flex justify-content-center align-items-center" style="min-height: 300px;">
            <p-progressSpinner
                strokeWidth="4"
                [style]="{width: '60px', height: '60px'}"
                animationDuration=".8s">
            </p-progressSpinner>
        </div>
    }

    @if (formReady) {
        <div class="d-flex w-100 justify-content-end mb-3">
            <button class="btn btn-primary" type="button" (click)="showDialogUploadFile = true">
                {{ optionsUploadFile.uploaded ? 'Ver Archivo' : 'Subir Archivo' }}
            </button>
        </div>

        <app-reactive-form-builder
            (formChanges)="formChanges($event[0], $event[1])"
            (goBack)="goBack()"
            [form]="form.formFields"
            [dropdownLoadTrigger]="dropdownLoadTrigger"
            [id]="getModel().id ?? ''"
            [request]="this.getType() === 1 ? this.tareasApi.ecorregimenes.PUT : this.tareasApi.ecorregimenes.POST"
            [getRequest]="tareasApi.ecorregimenes.GET">
        </app-reactive-form-builder>
    }
</p-panel>

<app-upload-file
    [showUploadDialog]="showDialogUploadFile"
    [options]="optionsUploadFile"
    (eventClose)="showDialogUploadFile = false"
    (eventUpload)="handleEventUpload($event)">
</app-upload-file>
